<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <parametros-aderencia-bdgd ref="aderenciaBdgdParams" />
        </v-col>

        <v-col cols="12">
          <v-btn
            id="btn-save-aderencia-bdgd"
            color="green"
            min-width="100"
            style="float: right;"
            :disabled="invalid"
            :loading="loading"
            @click="salvarAderenciaBdgd()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>

import AderenciaBdgdService from "@/services/AderenciaBdgdService";
import tourMixins from '@/mixins/tourMixins';

export default {
  name: "AderenciaBdgdEdit",
  
  mixins: [tourMixins],

  components: {
    ParametrosAderenciaBdgd: () => import("@/components/aderenciaBdgd/ParametrosAderenciaBdgd.vue")
  },
  
  mounted() {
    this.iniciarTourPagina();
  },

  data() {
    return {
      loading: false,
      arrTour: [
        {
          element: '#titulo-aderencia-bdgd',
          intro: 'Aqui você poderá inserir um nome para seu relatório de aderência de BDGD.',
          scrollTo: "tooltip",
          position: 'right'
        }, 
        {
          element: '#tipo-aderencia-bdgd',
          intro: 'Aqui você poderá selecionar a base para seu relatório de aderência de BDGD (Completa, Blindada ou Incremental).',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: '#date-picker-aderencia-bdgd-data-ais',
          intro: 'Aqui você poderá inserir a data base do AIS.',
          scrollTo: "tooltip",
          position: 'left'
        },
        {
          element: '#date-picker-aderencia-bdgd-data-bdgd',
          intro: 'Aqui você poderá inserir a data base da BDGD.',
          scrollTo: "tooltip",
          position: 'left'
        },
        {
          element: '#tucs-aderencia-bdgd',
          intro: 'Aqui você poderá selecionar as TUCs que irão compor o resultado de seu relatório de aderência de BDGD.',
          scrollTo: "tooltip",
          position: 'left'
        },
        {
          element: '#btn-save-aderencia-bdgd',
          intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar seu relatório de aderência de BDGD.',
          scrollTo: "tooltip",
          position: 'left'
        },
      ]
    };
  },


  methods: {
    salvarAderenciaBdgd() {
      this.loading = true;
      
      const user = this.$store.getters.getUser;
      const data = this.$refs.aderenciaBdgdParams.exportData();

      AderenciaBdgdService.salvarAderenciaBdgd(data)
        .then(result => {
          this.$router.push({ name: "Aderência BDGD Histórico" });
          this.$toast.success("Aderência BDGD salva com sucesso.", "", { position: "topRight" });
        })
        .catch(err => {
          console.log("Erro: ", err);
          this.$toast.error("Erro ao salvar Aderência BDGD.", "", { position: "topRight" });
        })
        .finally(() => this.loading = false);
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  }
};
</script>